import { BaseMutations } from '@/store/base-mutations';
import { Projects, DetailsFilters } from '@/modules/projects/types';
import { PaginationProps, TableOptions } from '@/types';
import ProjectDetailsState from './state';

export default class ProjectDetailsMutations extends BaseMutations<ProjectDetailsState> {
  SET_PRODUCTS(products: Projects.Product[]) {
    this.state.products = products;
  }

  SET_EQUIPMENTS(equipments: Projects.Equipments[]) {
    this.state.equipments = equipments;
  }

  SET_COMPETITORS(competitors: Projects.Competitors[]) {
    this.state.competitors = competitors;
  }

  SET_HISTORY(history: Projects.History[]) {
    this.state.history = history;
  }

  SET_ORDERS_REALIZATIONS(items: Projects.OrdersRealizations[]) {
    this.state.orders_realizations = items;
  }

  SET_REGIONS(regions: Projects.Regions[]) {
    this.state.regions = regions;
  }

  UPD_REALIZATIONS_FILTER_KEY({ key, value }: { key: keyof DetailsFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  RESET_REALIZATIONS_FILTERS() {
    this.state.realizations_filters.document_type = false;
  }

  TOGGLE_PRODUCTS_LOADING(toggle: boolean) {
    this.state.products_loading = toggle;
  }

  TOGGLE_EQUIPMENTS_LOADING(toggle: boolean) {
    this.state.equipments_loading = toggle;
  }

  SET_EQUIPMENTS_TABLE_OPTIONS(value: TableOptions) {
    this.state.equipments_table_options = value;
  }

  UPD_EQUIPMENTS_PAGINATION_FIELD({ key, value }: { key: keyof PaginationProps, value: number }) {
    this.state.equipments_pagination_props[key] = value;
  }

  UPD_EQUIPMENTS_TABLE_OPTIONS({ key, value }: { key: keyof TableOptions, value: unknown }) {
    this.state.equipments_table_options[key] = value;
  }

  TOGGLE_COMPETITORS_LOADING(toggle: boolean) {
    this.state.competitors_loading = toggle;
  }

  SET_COMPETITORS_TABLE_OPTIONS(value: TableOptions) {
    this.state.competitors_table_options = value;
  }

  UPD_COMPETITORS_PAGINATION_FIELD({ key, value }: { key: keyof PaginationProps, value: number }) {
    this.state.competitors_pagination_props[key] = value;
  }

  UPD_COMPETITORS_TABLE_OPTIONS({ key, value }: { key: keyof TableOptions, value: unknown }) {
    this.state.competitors_table_options[key] = value;
  }

  TOGGLE_HISTORY_LOADING(toggle: boolean) {
    this.state.history_loading = toggle;
  }

  SET_HISTORY_TABLE_OPTIONS(value: TableOptions) {
    this.state.history_table_options = value;
  }

  UPD_HISTORY_PAGINATION_FIELD({ key, value }: { key: keyof PaginationProps, value: number }) {
    this.state.history_pagination_props[key] = value;
  }

  UPD_HISTORY_TABLE_OPTIONS({ key, value }: { key: keyof TableOptions, value: unknown }) {
    this.state.history_table_options[key] = value;
  }

  TOGGLE_REALIZATIONS_LOADING(toggle: boolean) {
    this.state.realizations_loading = toggle;
  }

  SET_REALIZATIONS_TABLE_OPTIONS(value: TableOptions) {
    this.state.realizations_table_options = value;
  }

  UPD_REALIZATIONS_PAGINATION_FIELD({ key, value }: { key: keyof PaginationProps, value: number }) {
    this.state.realizations_pagination_props[key] = value;
  }

  UPD_REALIZATIONS_TABLE_OPTIONS({ key, value }: { key: keyof TableOptions, value: unknown }) {
    this.state.realizations_table_options[key] = value;
  }

  SET_CART_IS_EMPTY(value: boolean) {
    this.state.cart_is_empty = value;
  }
}
